import * as Yup from "yup";

import getFileExtension from "utils/getFileExtension";

const imageExt = ["jpg", "png", "jpeg"];

export const complaintValidationSchema = Yup.object({
  consumerNumber: Yup.string().required("Customer number is required"),
  utilityId: Yup.number().min(1, "Please select utility"),
  utilityIssueId: Yup.string()
    .required("Please select utility issue")
    .nullable(),
  severity: Yup.string().required("Severity is required"),
  description: Yup.string().when("utilityIssueId", {
    is: "otherIssue",
    then: (schema) => schema.required("Description is required"),
  }),
  complaintDocuments: Yup.array()
    .test("isValidFileType", "Only images and videos are allowed", (files) => {
      return files.every(
        ({ type }) => type.startsWith("image/") || type.startsWith("video/")
      );
    })
    .test(
      "isValidFileExtention",
      "Invalid file format, Please upload images in jpg, png, or jpeg and videos in mp4 formate. ",
      (files) => {
        return files.every(({ type, name }) => {
          const fileExtension = getFileExtension(name)?.toLowerCase();
          if (type.startsWith("image/")) {
            return imageExt.includes(fileExtension);
          }
          return fileExtension === "mp4";
        });
      }
    )

    .test(
      "isFileSizeValid",
      "Images are must be up to 600kb and videos are up to 2MB",
      (files) => {
        return files.every(({ type, size }) => {
          if (type.startsWith("image/")) {
            return size <= 614400;
          }
          return size <= 2097152;
        });
      }
    ),
});
